var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlavancar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4603 31V28H62.6612V31H30.4603ZM30.7111 60V47.1H28.2534V44.1L30.4603 34H62.611L64.8179 44.1V47.1H62.3602V60H59.3508V47.1H49.8711V60H30.7111ZM33.7205 57H46.8617V47.1H33.7205V57ZM31.2127 44.1H61.8586L60.3038 37H32.7675L31.2127 44.1Z",
    fill: "#737791"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9804_103922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.3602,
    cy: 32,
    rx: 10.0314,
    ry: 10,
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3414 31.5L57.4022 32.4694L61.6079 28.6331V37H63.1126V28.6331L67.3107 32.4763L68.3791 31.5L62.3602 26L56.3414 31.5Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9544 46C91.9544 71.1275 71.5202 91.5 46.3099 91.5C21.0997 91.5 0.665436 71.1275 0.665436 46C0.665436 20.8725 21.0997 0.5 46.3099 0.5C71.5202 0.5 91.9544 20.8725 91.9544 46Z",
    stroke: "#737791"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9804_103922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0754,
    height: 24,
    fill: "white",
    transform: "translate(50.3225 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlavancar);
export default __webpack_public_path__ + "static/media/alavancar.277466beca50aa3fa1bdacb7cc9303dc.svg";
export { ForwardRef as ReactComponent };